var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 66,
    r: 60,
    stroke: "#1B9075",
    strokeOpacity: 0.25,
    strokeWidth: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66 6C55.4689 6 45.1232 8.77181 36.0027 14.0369C26.8822 19.302 19.3081 26.8749 14.0416 35.9946C8.7751 45.1142 6.00166 55.4594 6 65.9906C5.99835 76.5217 8.76854 86.8678 14.0322 95.9891",
    stroke: "#1B9075",
    strokeWidth: 12,
    strokeMiterlimit: 16
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.3e8ce47798a31557a2f2634f833d7b8c.svg";
export { ForwardRef as ReactComponent };